import React, { Component } from 'react';
import { Col, Button, FormGroup, Label, Table, Modal } from 'reactstrap';
import { connect } from "react-redux";
import classnames from 'classnames';
import ErrorGif from '../../../../Assets/images/Error.gif';
import * as ErrorMessages from '../../../../Resources/ErrorMessages';
import { GetTraneSites, CreateTraneUser, GetTraneUser, EditTraneUser, UpdateSCCredentials } from '../../../../action/Administration/administrationAction';

class SiteDetails extends Component {
    componentWillMount() {
        this.props.GetTraneSites();
        this.props.GetTraneUser();
    }

    constructor(props) {
        super(props);
        this.state = {
            error_msg: false,
            api_error_msg: false,
            ErrorDetails: "Error: You left necessary fields blank or entered invalid values.",
            APIErrorDetails: '',
            modal: false,
            hide: false,
            userId: '',
            IsEdit: false,
            SiteId: 0,
            ScUserId: '',
            IsScReset: true
        }
    }

    passwordValidation(Username,Password,ConfirmPassword){
        var IsValid = true;
        this.setState({error_msg: false, api_error_msg: false});
        if(Username === "" || Password === "" || ConfirmPassword === ""){
            IsValid = false;
            this.setState({
                error_msg: true,
                ErrorDetails:"Error: You left necessary fields blank or entered invalid values."
            });
        }
        if (Password !== ConfirmPassword){
            IsValid = false;
            this.setState({
                error_msg: true,
                ErrorDetails:"Password and the confirmation password should be same."
            });
        }
        return IsValid;
    }

    OnResetSCPassword(SiteId, UserId){
        this.setState({ modal: true, SiteId: SiteId, userId: UserId, ScUserId: UserId, IsScReset: true });
    }

    SaveSCCredentials(){
        var username = this.refs.Username.value;
        var password = this.refs.Pwd.value;
        var confirmpassword = this.refs.Cpwd.value;
        if(this.passwordValidation(username,password,confirmpassword)){
            var data = {
                "siteId": this.state.SiteId,
                "userId": username,
                "password": password
            }
            
            const  actionResponse  =  this.props.UpdateSCCredentials(data);
                actionResponse.then((result) => {
                    var l_Status = (this.props.Error_Status.errorCode === 26 || this.props.Error_Status.errorCode === 27) ? true : false;
                    var l_ErrorCode = this.props.Error_Status.errorCode;
                    this.setState({
                        api_error_msg: l_Status, 
                        APIErrorDetails : (l_Status === true && l_ErrorCode === 26) ? ErrorMessages.ErrorCode_26 : (l_Status === true && l_ErrorCode === 27) ? ErrorMessages.ErrorCode_27 : ''
                    })
                    if(!l_Status)
                        this.CloseModal();
                })
        }
    }

    TraneUser() {
        this.setState({ modal: true, userId: '', IsScReset: false });
    }

    OnResetPassword(UserId) {
        this.setState({ modal: true, userId: UserId, IsEdit: true, IsScReset: false });
    }

    CloseModal() {
        this.setState({ 
            IsEdit: false, 
            userId: '', 
            modal: false, 
            SiteId: 0, 
            ScUserId: '', 
            IsScReset: true,
            error_msg: false,
            api_error_msg: false, 
        });
    }

    SaveTraneUser() {
        var username = this.refs.Username.value;
        var password = this.refs.Pwd.value;
        var confirmpassword = this.refs.Cpwd.value;
        if(this.passwordValidation(username,password,confirmpassword)){
            var data = {
                "userId": username,
                "password": password
            }
            if (this.state.IsEdit) {
                const  actionResponse  =  this.props.EditTraneUser(data);
                actionResponse.then((result) => {
                    var l_Status = (this.props.Error_Status.errorCode === 26 || this.props.Error_Status.errorCode === 27) ? true : false;
                    var l_ErrorCode = this.props.Error_Status.errorCode;
                    this.setState({
                        api_error_msg: l_Status, 
                        APIErrorDetails : (l_Status === true && l_ErrorCode === 26) ? ErrorMessages.ErrorCode_26 : (l_Status === true && l_ErrorCode === 27) ? ErrorMessages.ErrorCode_27 : ''
                    })
                    if(!l_Status)
                        this.CloseModal();
                })
            }
            else{
                const  actionResponse  =  this.props.CreateTraneUser(data);
                actionResponse.then((result) => {
                    var l_Status = (this.props.Error_Status.errorCode === 26 || this.props.Error_Status.errorCode === 27) ? true : false;
                    var l_ErrorCode = this.props.Error_Status.errorCode;
                    this.setState({
                        api_error_msg: l_Status, 
                        APIErrorDetails : (l_Status === true && l_ErrorCode === 26) ? ErrorMessages.ErrorCode_26 : (l_Status === true && l_ErrorCode === 27) ? ErrorMessages.ErrorCode_27 : ''
                    })
                    if(!l_Status)
                        this.CloseModal();
                })
            }
        }
    }

    render(Discovered_buildings_list_response, getLabels, getUsers) {
        let BuildingsList, Error_Message, API_Error_Message;
        // let label = this.props.getLabels;
        let DiscoveredBuildings = this.props.Discovered_buildings_list_response;
        // let TraneUsers = this.props.getUsers;

        (this.state.error_msg === true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> {this.state.ErrorDetails}</p> : Error_Message = " ";
        (this.state.api_error_msg === true) ? API_Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> {this.state.APIErrorDetails}</p> : API_Error_Message = " ";

        if (DiscoveredBuildings !== undefined && DiscoveredBuildings !== null && DiscoveredBuildings.length) {
            BuildingsList = DiscoveredBuildings.map(el => (
                <tr key={el.discoveryRequestId}>

                    <td><label>{el.siteName}</label></td>
                    <td><label>{el.userId}</label></td>
                    <td><label style={{ color: '#6890C6' }} className="link_cursor" onClick={() => { this.OnResetSCPassword(el.siteId,el.userId) }}>Reset</label></td>
                </tr>
            ));
        }else{
            BuildingsList = <tr> <td colSpan="3">No Records Found</td> </tr>
        }

        // if (TraneUsers !== undefined && TraneUsers !== null && TraneUsers !== "") {
        //     // eslint-disable-next-line react/no-direct-mutation-state
        //     this.state.hide = true;
        //     TraneUserList = <tr>
        //         <td>{TraneUsers.userId}</td>
        //         <td><label style={{ color: '#6890C6' }} className="link_cursor" onClick={() => { this.OnResetPassword(TraneUsers.userId) }}>Reset</label></td>
        //     </tr>
        // }else{
        //     TraneUserList = <tr> <td colSpan="2">No Records Found</td> </tr>
        // }

        return (
            <div>
                {/* <div>
                    <Form>
                        <FormGroup row>
                            <Col sm={{size:5}}>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <th width="40%"><p style={{fontFamily:'Verdana',fontSize:'12px'}}><b>Trane Connect User Account</b></p></th>
                                            <th>
                                            {
                                                this.state.hide ? "" :
                                                <Button className="btn btn-success" onClick={() => { this.TraneUser() }}>Add User</Button>
                                            }
                                            </th>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 5 }}>
                                <Table striped responsive className="Custom_table" style={{ 'width': '50%' }}>
                                    <tbody>
                                        <tr>
                                            <th>UserName</th>
                                            <th></th>
                                        </tr>
                                        {TraneUserList}
                                    </tbody>
                                </Table>
                            </Col>
                        </FormGroup>
                    </Form>
                </div> */ }
                <br />
                <p style={{fontFamily:'Verdana',fontSize:'12px'}}><b>&nbsp;&nbsp;Building User Account</b></p>
                <div className="table_container">
                    <Table striped responsive className="Custom_table" style={{ 'width': '50%' }}>
                        <tbody>
                            <tr>

                                <th>Building Name</th>
                                <th>UserName</th>
                                <th></th>
                            </tr>
                            {BuildingsList}
                        </tbody>
                    </Table>
                </div>
                <Modal isOpen={this.state.modal} style={{ width: '450px', height: '225px' }} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    {Error_Message}
                    {API_Error_Message}
                    <div className="form_group_modal" style={{ padding: "1px" }}>
                        <Label className="Custom_label"><b>UserName</b></Label>
                        <input className="InputFieldStyle default-input" ref="Username" type="text" style={{ width: '150px' }} defaultValue={this.state.userId} />
                    </div>
                    <div className="form_group_modal" style={{ padding: "1px" }}>
                        <Label className="Custom_label"><b>Password</b></Label>
                        <input className="InputFieldStyle default-input" ref="Pwd" type="password" style={{ width: '150px' }} />
                    </div>
                    <div className="form_group_modal" style={{ padding: "1px" }}>
                        <Label className="Custom_label"><b>Confirm Password</b></Label>
                        <input className="InputFieldStyle default-input" ref="Cpwd" type="password" style={{ width: '150px' }} />
                    </div>
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-black btn-md" onClick={() => { this.CloseModal() }} > Cancel </Button>
                            <Button className="btn-black btn-md" hidden={this.state.IsScReset} onClick={() => { this.SaveTraneUser() }} > Save </Button>
                            <Button className="btn-black btn-md" hidden={!this.state.IsScReset} onClick={() => { this.SaveSCCredentials() }} > Save </Button>
                        </Col>
                    </FormGroup>
                </Modal>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        Discovered_buildings_list_response: state.InstallationsRootReducer.TraneSites,
        Error_Status: state.InstallationsRootReducer.TraneConnectStatus,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
        getUsers: state.InstallationsRootReducer.Traneuser
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTraneSites: () => dispatch(GetTraneSites()),
        UpdateSCCredentials: (data) => dispatch(UpdateSCCredentials(data)),
        CreateTraneUser: (data) => dispatch(CreateTraneUser(data)),
        GetTraneUser: () => dispatch(GetTraneUser()),
        EditTraneUser: (data) => dispatch(EditTraneUser(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteDetails);